var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-sm":""}},[_c('v-layout',[_c('v-flex',{attrs:{"lg8":"","offset-lg2":""}},[_c('leader-boards',{attrs:{"players":_vm.players}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }